export const photos = [
    {
      src: "https://static.wixstatic.com/media/e49d9d_4c9c1078af194c0b9e1523abbc0977d9~mv2_d_6519_4351_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_4c9c1078af194c0b9e1523abbc0977d9~mv2_d_6519_4351_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_9238300a75c14650b5e1ce5f0dc8a0fa~mv2_d_6000_3914_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_9238300a75c14650b5e1ce5f0dc8a0fa~mv2_d_6000_3914_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_a53c503d8d9f41e1ac721bd434751735~mv2_d_6000_4000_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_a53c503d8d9f41e1ac721bd434751735~mv2_d_6000_4000_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_844199ad3a73414cbbcf28eddcee0f80~mv2_d_5885_3929_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_844199ad3a73414cbbcf28eddcee0f80~mv2_d_5885_3929_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_d75ed7e5d53d42aaa55a1385c105adf6~mv2_d_6016_4016_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_d75ed7e5d53d42aaa55a1385c105adf6~mv2_d_6016_4016_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_7ed1b268caad4c56a9e15ef7c22e630c~mv2_d_3000_2250_s_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_7ed1b268caad4c56a9e15ef7c22e630c~mv2_d_3000_2250_s_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_ccdc6093c12946eab438bc9e0f9f0018~mv2_d_5689_3798_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_ccdc6093c12946eab438bc9e0f9f0018~mv2_d_5689_3798_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_062b71a4d2474f0090b82b62a6d9f345~mv2_d_5929_3958_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_062b71a4d2474f0090b82b62a6d9f345~mv2_d_5929_3958_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_cd957776623d4410ba9ec00111393c81~mv2_d_6016_4016_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_cd957776623d4410ba9ec00111393c81~mv2_d_6016_4016_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_df5bd76c54cf43dd932a79fda2891dca~mv2_d_5629_3758_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_df5bd76c54cf43dd932a79fda2891dca~mv2_d_5629_3758_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_d33a9f5f8b7649de8638af64aa0f7346~mv2_d_6016_4016_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_d33a9f5f8b7649de8638af64aa0f7346~mv2_d_6016_4016_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_4fdb74962b4041c7b917404748915d9e~mv2_d_5585_3728_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_4fdb74962b4041c7b917404748915d9e~mv2_d_5585_3728_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_a9720827390e486aa4dba538df3ac77f~mv2_d_6016_4016_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_a9720827390e486aa4dba538df3ac77f~mv2_d_6016_4016_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_3e7dbc8480b649e3b7c8d6f33cb00c88~mv2_d_6016_4016_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_3e7dbc8480b649e3b7c8d6f33cb00c88~mv2_d_6016_4016_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_ab983c917c1341dfadc5ad8482125f62~mv2_d_5934_3961_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_ab983c917c1341dfadc5ad8482125f62~mv2_d_5934_3961_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
    {
      src: "https://static.wixstatic.com/media/e49d9d_5089088e06f8497cad353f497b6710e6~mv2_d_5931_3959_s_4_2.jpg",
      thumbnail: "https://static.wixstatic.com/media/e49d9d_5089088e06f8497cad353f497b6710e6~mv2_d_5931_3959_s_4_2.jpg",
      thumbnailWidth: 400,
      thumbnailHeight: 250,
    },
  ];
